import { render } from "./Index.vue?vue&type=template&id=1fd5b803"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"components/Customers/Partials/Bottombar/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1fd5b803"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1fd5b803', __exports__)) {
    api.reload('1fd5b803', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=1fd5b803", () => {
    api.rerender('1fd5b803', render)
  })

}


export default __exports__